import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "serp__filter--label-container q-fs-6 q-d-inline" }
const _hoisted_2 = { class: "serp__filter--label" }
const _hoisted_3 = { class: "serp__filter--badge q-text-muted q-d-none" }




export default /*@__PURE__*/_defineComponent({
  __name: 'FilterLabel',
  props: ['filter'],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.filter.label), 1),
    _createElementVNode("small", _hoisted_3, " (" + _toDisplayString(__props.filter.count) + ")", 1)
  ]))
}
}

})